import React from 'react';
import { Car, Globe, Heart, LogOut } from 'lucide-react';

export function Header({ t, lang, changeLang, showFavourites, setShowFavourites, favourites, totalProfitPotential, onLogout, user }) {
  const userName = [user?.name, user?.surname].filter(Boolean).join(' ');

  return (
    <div className="sticky top-0 z-50 bg-slate-900/80 backdrop-blur-md border-b border-slate-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-5">
        {/* Main row */}
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <div className="flex items-center gap-2 sm:gap-3 mb-0.5">
              <Car className="w-7 h-7 sm:w-10 sm:h-10 text-emerald-400 shrink-0" />
              <h1 className="text-xl sm:text-3xl font-bold">Arbauto</h1>
              <span className="px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider bg-amber-500/20 text-amber-400 border border-amber-500/30 rounded-full shrink-0">Beta</span>
            </div>
            <p className="text-xs sm:text-sm text-slate-400">
              {t('subtitle')}
              <span className="ml-2 sm:ml-3 text-emerald-400">● {t('live')}</span>
            </p>
          </div>
          <div className="flex items-center gap-2 sm:gap-6 shrink-0">
            <div className="text-right hidden sm:block">
              <div className="text-xs text-slate-400">{t('totalPotential')}</div>
              <div className="text-lg font-bold text-emerald-400">€{totalProfitPotential.toLocaleString()}</div>
            </div>
            <button
              onClick={() => {
                const langs = ['en', 'fr', 'pt', 'es'];
                const next = langs[(langs.indexOf(lang) + 1) % langs.length];
                changeLang(next);
              }}
              className="flex items-center gap-1.5 px-2.5 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 border border-slate-600 transition-colors text-sm"
              title="Change language"
            >
              <Globe className="w-4 h-4 text-slate-400" />
              <span className="uppercase font-medium text-xs">{lang}</span>
            </button>
            <button
              onClick={() => setShowFavourites(!showFavourites)}
              className={`flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg font-medium transition-colors ${
                showFavourites
                  ? 'bg-rose-500 hover:bg-rose-600'
                  : 'bg-emerald-500 hover:bg-emerald-600'
              }`}
            >
              <Heart className={`w-4 h-4 ${showFavourites ? 'fill-current' : ''}`} />
              <span className="hidden sm:inline">{t('favourites')}{favourites.length > 0 ? ` (${favourites.length})` : ''}</span>
              {favourites.length > 0 && <span className="sm:hidden text-sm">{favourites.length}</span>}
            </button>
            {onLogout && (
              <div className="flex items-center gap-2 sm:gap-3">
                {/* Desktop: full name + company */}
                {userName && (
                  <div className="hidden sm:block text-right">
                    <div className="text-sm font-medium text-slate-200 leading-tight">{userName}</div>
                    {user?.company && (
                      <div className="text-[11px] text-slate-500 leading-tight">{user.company}</div>
                    )}
                  </div>
                )}
                <button
                  onClick={onLogout}
                  className="flex items-center gap-1.5 px-2.5 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 border border-slate-600 transition-colors text-sm"
                  title={t('logout')}
                >
                  <LogOut className="w-4 h-4 text-slate-400" />
                  <span className="hidden sm:inline uppercase font-medium text-xs text-slate-400">{t('logout')}</span>
                </button>
              </div>
            )}
          </div>
        </div>
        {/* Mobile: user info row below header */}
        {userName && (
          <div className="sm:hidden flex items-center justify-between mt-2 pt-2 border-t border-slate-800/50">
            <div className="text-xs text-slate-500 shrink-0">
              <span className="text-emerald-400 font-medium">€{totalProfitPotential.toLocaleString()}</span>
              <span className="ml-1">{t('totalPotential')}</span>
            </div>
            <div className="text-xs text-slate-400 truncate ml-2 text-right">
              <span className="text-slate-300 font-medium">{userName}</span>
              {user?.company && <span className="text-slate-500"> · {user.company}</span>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
